exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".add-image {\n    display: block;\n    width: 70%;\n    height: auto;\n    min-height: 200px;\n    margin: 0px auto;\n}", ""]);

